import { IFormChecklistItem } from "../../modules/EmployeeTaxForms/types";
import { requestForms } from "../serviceForms";

export type GetChecklistResponse = { items: IFormChecklistItem[] };

export const getChecklist = async (
  contextId: string
): Promise<GetChecklistResponse> =>
  requestForms<GetChecklistResponse>({
    method: "GET",
    path: "/checklist",
    query: { payeeEngagementId: contextId }
  });
